export default {"src":"/_next/static/media/parachuting.f9b7b673.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};